import { Coords, serializeCoord } from 'src/geo/Coords'
import { DisplayMode } from 'src/business/Warehouse/detail/WarehouseDetailTabs'
// eslint-disable-next-line @typescript-eslint/no-var-requires
const routes = require('src/routing/routes').default

export const warehousePages = {
    WarehouseDetail: {
        path: routes.warehouseDetail.path,
        comp: () => import('src/business/Warehouse/detail/WarehouseDetailPage'),
        to: (p: { id: number; display?: DisplayMode }): string =>
            `/location/${p.id}${p.display ? `?display=${p.display}` : ''}`
    },
    WarehouseSearch: {
        path: routes.warehouseSearch.path,
        comp: () => import('src/business/Warehouse/search/WarehouseSearchPage'),
        to: ({
            location,
            zoom
        }: { location?: Coords; zoom?: number } = {}): string => {
            let res = routes.warehouseSearch.path

            if (location && zoom)
                res += `?location=${serializeCoord(location)}&zoom=${zoom}`

            return res
        }
    }
}
